import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useContext, useEffect } from "react";
import { injectIntl } from "react-intl";
import { isEmpty } from "../utils/nativeUtils";
import { ErrorBoundary, WithSearch } from "@elastic/react-search-ui";
import { i18nConfig } from "../i18nConfig";
import { checkIfVersionExists, hasProductBeenSelected, hasVersionBeenSelected } from "../utils/functions";
import { FilterOptionEnum, FilterTypeEnum } from "../models/dataModel";
import { UIStateStoreContext } from "../stores/uiStateStore";
import { CustomSidebar } from "./sidebar/CustomSidebar";
import { Results } from "./results/Results";
import { Spinner } from "./common/Spinner";
import { ErrorView } from "./common/ErrorView";
import { SearchField } from "./search-field/SearchField";
const CustomLayout = injectIntl(({ intl, results, wasSearched, isLoading, facets, filters, resultSearchTerm, addFilter, }) => {
    const uiStore = useContext(UIStateStoreContext);
    const notVersionSpecific = i18nConfig.messages[intl.defaultLocale]["facets.software_version.notVersionSpecific"];
    useEffect(() => {
        if (hasProductBeenSelected(filters))
            uiStore.setFacetState(FilterOptionEnum.PRODUCT, true);
        if (hasVersionBeenSelected(filters))
            uiStore.setFacetState(FilterOptionEnum.VERSION, true);
    }, []);
    // Add 'Not version-specific' version if a version filter exists when landing on the ResultPage view
    useEffect(() => {
        if (!!checkIfVersionExists(facets, notVersionSpecific) && !!hasVersionBeenSelected(filters)) {
            addFilter(FilterOptionEnum.VERSION, notVersionSpecific, FilterTypeEnum.ANY);
        }
    }, [wasSearched]);
    return (_jsx("div", { className: "sui-layout", children: _jsx("div", { className: "sui-layout-body", children: isLoading && isEmpty(results) ? (_jsx(Spinner, {})) : (_jsx(Fragment, { children: wasSearched && resultSearchTerm ? (_jsxs("div", { className: "sui-layout-body__inner", children: [_jsx(CustomSidebar, {}), _jsx(Results, { results: results })] })) : (_jsx(SearchField, { filters: filters })) })) }) }));
});
/**
 * Main component for the search results view.
 */
export const ResultPage = () => {
    return (_jsx("div", { className: "trimble-search", id: "resultPage", "data-testid": "result-page", children: _jsx(ErrorBoundary, { view: ErrorView, children: _jsx(WithSearch, { mapContextToProps: ({ results, wasSearched, isLoading, facets, filters, resultSearchTerm, addFilter }) => ({
                    results,
                    wasSearched,
                    isLoading,
                    facets,
                    filters,
                    resultSearchTerm,
                    addFilter,
                }), children: (props) => _jsx(CustomLayout, { ...props }) }) }) }));
};
